<template>
    <div>
        <div class="row">
            <div class="col-12 px-0">
                <ul class="qf-dashboard-navigation">
                    <li class="qf-active-nav">
                        <a href="#!" @click.prevent>
                            {{$ml.get('Search_Result')}}
                        </a>
                    </li>
                    <li v-if="loading">
                        <a @clisk.prevent>
                            <font-awesome-icon icon="spinner" class="fa-spin"/>
                        </a>
                    </li>
                    <li></li>
                </ul>
            </div>
        </div>
        <div class="col-12 pb-3">
            <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
        </div>
        <div class="row" v-if="loading">
            <div class="col-12 text-center h2">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
            </div>
        </div>
        <div v-else>
            <div class="row align-items-center">
                <div class="col-6">
                    <div class="d-flex">
                        <div class="qf-mw-100px">
                            <img :src="`${$store.state.baseUrl}${trademark.logo}`" alt="logo" class="img-fluid"
                                 v-if="trademark.logo && trademark.logo.length">
                            <img src="../../../assets/img/placeholders/logo.png" alt="logo" class="img-fluid" v-else>
                        </div>
                    </div>
                </div>
            </div>
            <trademark-details :trademark="trademark"></trademark-details>
        </div>
    </div>
</template>

<script>
    import TrademarkDetails from '../../common/TrademarkDetails'

    export default {
        name: "SingleSearchResult",
        components: {TrademarkDetails},
        props: {
            id: [String, Number]
        },
        data() {
            return {
                trademark: {},
                loading: true
            }
        },
        mounted() {
            this.$store.dispatch('trademark', this.id).then(response => {
                this.trademark = response;
                this.loading = false
            });
        }
    }
</script>

<style scoped>

</style>
